module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-Kf-Lc.700ce618.png";